import React, {Component, useState, useEffect} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import DivisionInfoContent from '../components/DivisionInfoContent'; 
import axios from 'axios'; 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import withRouter from '../components/withRouter';
import {api_base_url, base_url} from '../common/Constants'; 
import { Helmet } from "react-helmet";

class DivisionInfo extends React.Component{

    constructor(props){
           super(props);
   
           
           this.state = {
               division : [],
               loading : 1 
           }
       }
       componentDidMount() {
    const divisions = JSON.parse(localStorage.getItem("divisions_slug") || "{}");
    const data = divisions?.[this.props.params.id] ?? null;
    this.setState({ division: data });
  }

  componentDidUpdate(prevProps) { 
    if (this.props.params?.id !== prevProps.params?.id) {
      const divisions = JSON.parse(localStorage.getItem("divisions_slug") || "{}");
      const data = divisions?.[this.props.params.id] ?? null;
 
      if (data !== this.state.division) {
        this.setState({ division: data });
      }
    }
  }
 
    render()
    { 
        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));

        return (
            <div>
                <Header/> 
                <Helmet>
                    <title>{"Division - "+this.state.division.title+" - "+metas[0].title}</title>  
                    <meta name="description" content={this.state.division.meta_description} />
                    <meta name="keywords" content={this.state.division.meta_title} />
                    <meta property="og:image" content={this.state.division.image}  />
                    <link rel="canonical" href={base_url+'division-info/'+this.state.division.slug} />
                </Helmet>
                <PageHeader title={this.state.division.title}  />
                <DivisionInfoContent  content={JSON.parse(localStorage.getItem("content"))}  division={this.state.division} divisions={JSON.parse(localStorage.getItem("divisions"))}  />    
                <Footer/>
      
        
        </div>
       
        )
    }

}
export default withRouter(DivisionInfo);;